import axios from 'axios';
import { setupInterceptors } from './authInterceptor';

const api3003 = axios.create({
    baseURL: process.env.REACT_APP_API_3003_URL,
});

setupInterceptors(api3003);

export default api3003;
